import PropTypes from 'prop-types';
import React from 'react';
import {
  Button,
  CardActions,
  CardMedia,
  Typography,
  Stack,
} from '@mui/material';
import {
  MembershipCard,
  MembershipModal,
  MembershipCardContent,
  MembershipStack,
} from './components';

function MembershipPromoModal({ open = false, onClose = () => {} }) {
  return (
    <MembershipModal
      open={open}
      aria-labelledby='membership-promo-subtitle'
      aria-describedby='membership-promo-title'
      disableEscapeKeyDown={true}>
      <MembershipCard>
        <CardMedia
          component='img'
          height='192'
          image='https://s3.eu-west-2.amazonaws.com/venue.scanner/img/membership-promo-media.png'></CardMedia>
        <MembershipStack spacing={4}>
          <MembershipCardContent>
            <Typography variant='subtitle1' id='membership-promo-subtitle'>
              Don&apos;t want to pay commission on bookings?
            </Typography>
            <Typography variant='h5' component='h1' id='membership-promo-title'>
              Keep all of your revenue with a 0% commission VenueScanner
              membership
            </Typography>
          </MembershipCardContent>
          <CardActions>
            <Stack direction='row' spacing={1}>
              <Button
                href='https://www.venuescanner.com/pages/landing/case-study/commission-free#memberships'
                target='_blank'
                rel='noreferrer'
                size='large'
                variant='contained'>
                Show details
              </Button>
              <Button
                variant='text'
                color='white'
                size='large'
                onClick={onClose}>
                Close
              </Button>
            </Stack>
          </CardActions>
        </MembershipStack>
      </MembershipCard>
    </MembershipModal>
  );
}

MembershipPromoModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default MembershipPromoModal;
